import { AxiosResponse } from 'axios';

function getFilename(headerContentDisposition: string): string {
  return headerContentDisposition.split('"')[1];
}

export function downloadExcel(response: AxiosResponse): void {
  const blob = new Blob([response.data]);
  const url = window.URL.createObjectURL(blob);

  const a = Object.assign(document.createElement('a'), {
    href: url,
    style: 'display:none',
    download: getFilename(response.headers['content-disposition']),
  });
  a.click();
  window.URL.revokeObjectURL(url);
  a.remove();
}
